import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLogin from '../views/AdminLogin.vue'
import AdminLayout from '../components/layout/AdminLayout.vue'
import AdminDashboardView from '../views/AdminDashboardView.vue'
import AdminOrdersView from '../views/AdminOrdersView.vue'
import AdminWithdrawView from '../views/AdminWithdrawView.vue'
import AdminMerchantsView from '../views/AdminMerchantsView.vue'
import AdminWithdrawFeeView from '../views/AdminWithdrawFeeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'admin-login',
    component: AdminLogin,
    meta: { public: true }
  },
  {
    path: '/',
    component: AdminLayout,
    children: [
      {
        path: '',
        redirect: { name: 'admin-dashboard' }
      },
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: AdminDashboardView,
        meta: { title: '账户总览' }
      },
      {
        path: 'orders',
        name: 'admin-orders',
        component: AdminOrdersView,
        meta: { title: '订单管理' }
      },
      {
        path: 'withdraw',
        name: 'admin-withdraw',
        component: AdminWithdrawView,
        meta: { title: '提现管理' }
      },
      {
        path: 'withdraw-fees',
        name: 'admin-withdraw-fees',
        component: AdminWithdrawFeeView,
        meta: { title: '提现手续费' }
      },
      {
        path: 'merchants',
        name: 'admin-merchants',
        component: AdminMerchantsView,
        meta: { title: '商家管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.path === '/login' && sessionStorage.getItem('cryptopay_admin_token')) {
    next({ path: '/dashboard', replace: true })
    return
  }

  const isPublic = to.matched.some((r) => r.meta && r.meta.public)
  if (isPublic) {
    next()
    return
  }

  if (!sessionStorage.getItem('cryptopay_admin_token')) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
